<template>
  <result-wrapper class="simple-result"
                  icon-name="songs"
                  :element-data="elementData">
    <i class="bi bi-music-note-list ms-2 icons"></i>
    <span class="card-title ms-2">Songs</span>
  </result-wrapper>
</template>

<script>
import ResultWrapper from "@/components/card/ResultWrapper.vue";

export default {
  name: "SongsBox",
  props: {
    elementKey: String,
    elementData: Object,
  },
  components: {
    ResultWrapper,
  }
};
</script>

<style lang="scss" scoped></style>